import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "default-table-area recent-orders" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ms-2 ps-1" }
const _hoisted_10 = { class: "fw-medium fs-14" }
const _hoisted_11 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_12 = { class: "fs-12 fw-medium" }
const _hoisted_13 = { "aria-label": "Page navigation example" }
const _hoisted_14 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "mb-0" }, "Recent Orders", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search here",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
          ], 32),
          _cache[5] || (_cache[5] = _createStaticVNode("<select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Show All</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Order ID"),
                _createElementVNode("th", { scope: "col" }, "Customer"),
                _createElementVNode("th", { scope: "col" }, "Created"),
                _createElementVNode("th", { scope: "col" }, "Total"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.orderID
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.orderID), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-profile",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.customer.image,
                          class: "wh-40 rounded-3",
                          alt: "user"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.customer.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.created), 1),
                  _createElementVNode("td", null, "$" + _toDisplayString(item.total), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, " Showing " + _toDisplayString(_ctx.startItem + 1) + " to " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.filteredItems.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))])
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                  }, _toDisplayString(page), 9, _hoisted_15)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))])
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}